import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BusyLauncherComponent } from './controls/busy-launcher/busy-launcher.component';
import { RouterOutlet } from '@angular/router';
import { NavBarComponent } from './controls/nav-bar/nav-bar.component';
import { HeaderComponent } from './controls/header/header.component';
import { ThemeService } from './services/theme.service';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [HeaderComponent, NavBarComponent, RouterOutlet, BusyLauncherComponent]
})
export class AppComponent {
  // The same title the header shows, including the staging marker.
  readonly title = environment.appTitle;

  // Inject ThemeService to ensure it initializes on app startup
  constructor(private themeService: ThemeService, titleService: Title) {
    titleService.setTitle(this.title);
  }
}
